import React, { createContext, useContext, useEffect, useState } from 'react';

interface ContextProps {
  darkTheme: boolean;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ContextProps>({
  darkTheme: false,
  toggleTheme: () => {},
});

interface Props {
  children?: React.ReactNode;
}

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

const ThemeProvider: React.FC<Props> = ({ children }) => {
  const getValue = localStorage.getItem('darkTheme');
  const [darkTheme, setDarkTheme] = useState(getValue === "true" || false);

  const toggleThemeHandler = async () => {
    await setDarkTheme((prevState) => !prevState);
  };

  useEffect(() => {
    localStorage.setItem('darkTheme', String(darkTheme))
  }, [darkTheme])

  return (
    <ThemeContext.Provider
      value={{
        darkTheme: darkTheme,
        toggleTheme: toggleThemeHandler,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
